import { useEffect, useRef, useState } from "react";
import { Form, Formik, FormikProps } from "formik";

import {
    FormDateSelector,
    FormSelector,
} from "../FormElements/index";
import { Button } from "../Elements";
import { useDispatch } from "react-redux";
import FormFiltersShortList from "../FormElements/FormFiltersShortList";
import FormObserver from "../FormElements/FormObserver";
import { updateIsResetForm } from "../../../store/slices/formHelperSlice";
import { getcronJobRecordList } from "../../../store/slices/cronJobRecordListSlice";
import { ThunkDispatch } from "redux-thunk";
import { DateSelectorRefProps } from "../FormElements/FormDate";
import { buttonTexts } from "../../../constants/texts/buttonTexts";
import { OptionModel } from "../../../common/types/OptionModel";

type DateRangeProps = {
    startDate: string | any,
    endDate: string | any,
}

type FormProps = {
    dateRange: DateRangeProps,
    cronType: string
}

const initialValues = {
    dateRange: {
        startDate: null,
        endDate: null,
    },
    cronType: "",
}

const cronTypes: Array<OptionModel> = [
    {
        label: "Tümü",
        value: ""
    },
    {
        label: "Ödeme",
        value: "Ödeme",
    },
    {
        label: "Müşteri",
        value: "Müşteri",
    }
]

type Props = {
    isOpen: boolean,
    setFiltersIsOpen: (isOpen: boolean) => void
}

const Filters = ({ isOpen, setFiltersIsOpen }: Props) => {
    const formref = useRef<FormikProps<FormProps>>(null);
    const dateRangeRef = useRef<DateSelectorRefProps>(null);
    const isInitialRequest = useRef(true);
    const isMountedEffect = useRef(false);

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const [formValues, setFormValues] = useState(initialValues);

    useEffect(() => {

        if (!isMountedEffect.current) {
            isMountedEffect.current = true;
            selectRecordList();
        }
    }, []);

    const selectRecordList = () => {
        if (formref && formref.current) {
            formref.current.submitForm();
        }
    }

    function submitform() {
        formref.current?.submitForm();
    }

    const onSubmit = async (values: FormProps) => {
        var start = values.dateRange.startDate;
        var end = values.dateRange.endDate;
        var startDate = "";
        var endDate = "";
        if (start) {
            startDate = start.getDate() + "/" + (start.getMonth() + 1) + "/" + start.getFullYear();
        }
        if (end) {
            endDate = end.getDate() + "/" + (end.getMonth() + 1) + "/" + end.getFullYear();
        }

        const parameters = {
            startDate: startDate,
            endDate: endDate,
            cronType: values.cronType
        };

        dispatch(getcronJobRecordList(parameters));

        if (isInitialRequest.current) {
            isInitialRequest.current = false;
        } else {
            setFiltersIsOpen(false);
        }
    };

    const fields = [
        {
            key: "dateRange",
            label: "Tarih Aralığı",
            type: "object",
            datatype: "daterange"
        },
        {
            key: "cronType",
            label: "Görev Tipi",
            type: "select",
            options: cronTypes,
        },
    ];

    const resetDateRanges = (value: any) => {
        var keys = Object.keys(value);

        if (keys && keys.length > 0) {
            if (keys[0] == "dateRange") {
                dateRangeRef.current?.resetForm();
            }
        }
    }

    const onUpdate = (value: FormProps) => {
        setFormValues(Object.assign(formValues, value));
        resetDateRanges(value);
        submitform();
    };

    const clearFilters = () => {
        formref.current?.resetForm()

        dispatch(updateIsResetForm(true));
        setTimeout(() => {
            dispatch(updateIsResetForm(false));
        }, 1000);
        submitform();
    };

    return (
        <Formik
            innerRef={formref}
            initialValues={initialValues}
            onSubmit={onSubmit}
        >
            {({
                values,
                touched,
                errors,
            }) => (
                <Form>
                    <FormObserver
                        watch={(val: FormProps) => {
                            setFormValues(val);
                        }}
                    />
                    <div className={`mt-3 mx-4 mb-3 px-4 py-2 bg-white shadow-md rounded-md ${!isOpen ? "hidden" : ""}`}>
                        <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3">
                            <div className="flex flex-col justify-start px-0">
                                <div className="mt-1">
                                    <FormSelector
                                        options={cronTypes}
                                        name="cronType"
                                        placeholder="Tümü"
                                        label="Görev Tipi"
                                        error={errors.cronType}
                                        touched={touched.cronType}
                                        defaultValue={cronTypes?.find(s => s.value == formValues.cronType)?.value}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col justify-start px-0">
                                <div className="mt-1">
                                    <FormDateSelector
                                        label="Tarih Aralığı"
                                        name="dateRange"
                                        type="range"
                                        ref={dateRangeRef}
                                        nullable

                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end mt-2 mr-0">
                            <Button
                                type="button"
                                color="gray"
                                hover="gray"
                                size="xs"
                                className="mr-3"
                                callback={clearFilters}
                            >
                                <img src="/icons/delete-blue.svg" alt="deleteFilter" />
                                <span className='ml-3'>{buttonTexts.filterClear}</span>
                            </Button>
                            <Button type="submit" color="primary" hover="primary" size="xs">
                                <img src="/icons/prepare-white.svg" alt="prepare" />
                                <span className='ml-3 mr-3'>{buttonTexts.filterSubmit}</span>
                            </Button>
                        </div>
                    </div>
                    <div className={`m-4 px-4 py-3 bg-white shadow-md rounded-md ${isOpen ? "hidden" : ""}`} >
                        <FormFiltersShortList
                            formValues={{ ...values }}
                            fields={fields}
                            initialValues={initialValues}
                            callback={(val: FormProps) => onUpdate(val)}
                            clearFilter={() => {
                                clearFilters()
                                submitform();
                            }}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
}

export default Filters;